import { render, staticRenderFns } from "./MunicipalityLogo.vue?vue&type=template&id=48cff630&scoped=true&"
import script from "./MunicipalityLogo.vue?vue&type=script&lang=ts&"
export * from "./MunicipalityLogo.vue?vue&type=script&lang=ts&"
import style0 from "./MunicipalityLogo.vue?vue&type=style&index=0&id=48cff630&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cff630",
  null
  
)

export default component.exports